import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, disableNetwork, enableNetwork } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Force fresh data from server in development by clearing cache
if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  // Clear any cached data on page load
  setTimeout(() => {
    if (window.localStorage) {
      // Clear any Firestore-related cache
      Object.keys(window.localStorage).forEach(key => {
        if (key.includes('firebase') || key.includes('firestore')) {
          window.localStorage.removeItem(key);
        }
      });
    }
  }, 100);
}

// Initialize Analytics only in browser environment
export const analytics = typeof window !== 'undefined' && isSupported() ? getAnalytics(app) : null;